import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import API_URL from '../../../common/url';
import moment from 'moment';

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'lineOfBusiness') {
            params.secondLineName = undefined;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    render() {
        const { params, endMonth, startMonth, businessList, contractTypeList, signingUnitOptions, belongingToUnitOptions, ...rest } = this.props;
        const { lineOfBusiness } = params;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const secondLineOption = [...secondLineSet].map(i => ({ value: i, label: i }));
        const filters = [{
            name: '合同收入确认时间',
            key: 'date',
            type: 'monthPickerRange',
            typeProperty: {
                allowClear: false,
                keys: ['dateStart', 'dateEnd'],
                style:{position:"relative",top:"-5px"},
                disabledDate: current => current && (current.valueOf() < moment(startMonth).valueOf() || current.valueOf() > moment(endMonth).valueOf())
            }
        }, {
            name: '合同签署单位',
            key: 'signingUnit',
            type: 'select',
            typeProperty: {
                style: { width: 140 },
                list: signingUnitOptions,
            }
        }, {
            name: '收入归属单位',
            key: 'belongingToUnit',
            type: 'select',
            typeProperty: {
                list: belongingToUnitOptions,
            }
        }, {
            name: 'JDE主项目号',
            key: 'jdeMainCode',
            type: 'input',
            typeProperty: {
                style: { width: 100 },
            }
        }, {
            name: 'JDE项目号',
            key: 'jdeCode',
            type: 'input',
        }, {
            name: '项目简称',
            key: 'investigation',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'investigationName',
                style: {width: 160},
                placeholder: '输入名称检索',
                params: {limit: 20},
                url: API_URL.investigation.queryInvestigationByName,
                config: { id: 'investigationId', name: 'investigationName' }
            }
        }, {
            name: '客户JDE号',
            key: 'customerCompanyCode',
            type: 'input',
        }, {
            name: '客户全名',
            key: 'customerCompany',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'customerCompanyName',
                style: {width: 160},
                placeholder: '输入客户名称检索',
                params: {limit: 20},
                url: API_URL.investigation.queryCustomerCompanyByName,
                config: { id: 'customerCompanyId', name: 'customerCompanyName' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption
            }
        }, {
            name: '执行业务线二级分类',
            key: 'secondLineName',
            type: 'select',
            typeProperty: {
                disabled: !lineOfBusiness,
                list: secondLineOption,
            }
        }, {
            name: '合同开始时间',
            type: 'inputGroup',
            group: [{
                key: 'startOper',
                type: 'select',
                typeProperty: {
                    style: { width: 40 },
                    list: [
                        { label: '=', value: 'EQ' },
                        { label: '>', value: 'GT' },
                        { label: '≥', value: 'GE' },
                        { label: '<', value: 'LT' },
                        { label: '≤', value: 'LE' },
                    ],
                }
            }, {
                key: 'startTime',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 100 },
                }
            }]
        }, {
            name: '合同结束时间',
            type: 'inputGroup',
            group: [{
                key: 'endOper',
                type: 'select',
                typeProperty: {
                    style: { width: 40 },
                    list: [
                        { label: '=', value: 'EQ' },
                        { label: '>', value: 'GT' },
                        { label: '≥', value: 'GE' },
                        { label: '<', value: 'LT' },
                        { label: '≤', value: 'LE' },
                    ],
                }
            }, {
                key: 'endTime',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 100 },
                }
            }]
        }, {
            name: '计收入确认方式',
            key: 'contractTypeId',
            type: 'select',
            typeProperty: {
                list: contractTypeList.map(i => ({label: i.typeValue, value: i.typeConfigureId}))
            }
        }, {
            name: '过账编辑',
            key: 'postingEdit',
            type: 'select',
            typeProperty: {
                list: [
                    { value: 'N', label: 'N' },
                    { value: 'empty', label: '为空' },
                ]
            }
        }, {
            name: '类别码13',
            key: 'categoryCode13',
            type: 'input',
        }];
        return (
            <FilterBasic filters={filters} params={params} {...rest} onChange={this.handleChange} />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/financeManagement/otherChargesReport/Filter.js